<template>
  <div class="refund-express">
    <fixed-header title="售后物流"></fixed-header>
    <div class="refund-express__main">
      <p v-if="showUserAddress" class="refund-express__info">选择重发收货地址：</p>
      <div v-if="showUserAddress" :mg-stat-custom="'label=title&cont=点击地址&direct=web'" class="refund-express__address"
           mg-stat-click mg-stat-mod="refund_address" @click="gotoEdit">
        <section v-if="hasAddress" class="refund-express__address-user">
          {{ nowAddress.consignee }}&nbsp;&nbsp;{{ nowAddress.mobile }}
        </section>
        <section class="refund-express__address-detail">
          <i class="icon position"></i>
          <div>{{ showAddress(nowAddress, '新增地址') }}</div>
          <i :class="['icon', hasAddress?'left_arrow':'address_add']"></i>
        </section>
      </div>
      <!--      <p class="refund-express__common" v-if="showIsReturn">-->
      <!--        <span>物流公司</span>-->
      <!--        <input-item class="refund-express__common-check" v-model="delivery.expressName" type="text" placeholder="请填写物流公司"></input-item>-->
      <!--      </p>-->
      <section v-if="showIsReturn" class="refund-express__common" @click="isShowExpressPicker = true">
        <span>物流公司</span>
        <span class="refund-express__common-check">
          {{ delivery.expressName ? delivery.expressName : '请选择物流公司' }}
        </span>
        <i class="icon left_arrow"></i>
      </section>
      <p v-if="showIsReturn" class="refund-express__common">
        <span>物流单号</span>
        <input-item v-model="delivery.expressSn" class="refund-express__common-input" placeholder="请填写物流单号"
                    type="text"></input-item>
      </p>
      <p v-if="showIsReturn" class="refund-express__common">
        <span>物流运费</span>
        <input-item v-model="delivery.expressFee" class="refund-express__common-input" placeholder="请填写物流运费"
                    type="text"></input-item>
      </p>
      <div class="refund-express__mark">
        <p>
          注意：寄回后，请尽快联系在线客服提供{{coinName}}兑换订单号、快递凭证、运费凭证及支付宝收款账号和实名，客服登记后将为您安排退还垫付运费，不提供将无法退还。
        </p>
        <p style="color:red">
          非质量问题，因用户自己原因换货或者退货退款，需要用户自己支付寄回运费。
        </p>
      </div>
    </div>
    <div class="refund-express__button">
      <button @click="submitRefundExpress">保存</button>
    </div>

    <refund-picker
        :defaultKey="delivery.expressCode"
        :isShow="isShowExpressPicker"
        :option="expressOptions"
        headerTitle="快递公司"
        @changeVisible="(val) => (isShowExpressPicker = val)"
        @confirm="getExpress"
    >
    </refund-picker>
    <refund-levitate></refund-levitate>
  </div>
</template>
<script>
import InputItem from 'components/common/InputItem';
import FixedHeader from 'components/common/FixedHeader';
import RefundPicker from 'components/refund/RefundPicker';
import RefundLevitate from 'components/common/RefundLevitate';
import { checkNumber } from 'utils/string';
import * as orderApi from 'apis/order';
import * as userApis from 'apis/user';
import MgtvApi from 'MgtvApi';
import _ from 'lodash';
import { showAddress } from 'utils/order';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    RefundLevitate,
    FixedHeader,
    InputItem,
    RefundPicker,
  },
  data() {
    const {
      id, refundType, addressId, isReturn, goodsFrom,
    } = this.$route.query;
    return {
      id,
      refundType,
      isReturn,
      goodsFrom,
      isShowExpressPicker: false,
      delivery: {
        expressName: '',
        expressSn: '',
        expressCode: '',
        expressFee: '',
      },
      hasNoAddress: 1,
      nowAddressId: addressId ? Number(addressId) : 0,
      nowAddress: {
        consignee: '',
        mobile: '',
        province: {
          id: '',
          name: '',
        },
        city: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        address: '',
        addressId: 0,
        isDefault: false,
      },
      expressOptions: [
        { value: 'POST', title: '中国邮政' },
        { value: 'EMS', title: 'EMS' },
        { value: 'EYB', title: 'EMS快递包裹' },
        { value: 'STO', title: '申通快递' },
        { value: 'YTO', title: '圆通快递' },
        { value: 'YUNDA', title: '韵达快递' },
        { value: 'ZJS', title: '宅急送' },
        { value: 'DBKD', title: '德邦物流' },
        { value: 'TN', title: '特能' },
        { value: 'TAOBAO', title: '淘宝物流' },
        { value: 'ZTO', title: '中通物流' },
        { value: 'HTKY', title: '百世快递' },
        { value: 'TTKDEX', title: '天天快递' },
        { value: 'SF', title: '顺丰速运' },
        { value: 'ZTKY', title: '中铁物流' },
        { value: 'QFKD', title: '全峰快递' },
        { value: 'OTHER', title: '其他' },
      ],
    };
  },
  computed: {
    ...mapState('address', [
      'addressId',
    ]),
    hasAddress() {
      const { nowAddress } = this;
      return nowAddress && nowAddress.addressId;
    },
    showUserAddress() {
      // 换货才让用户选择地址
      return false;
    },
    showIsReturn() {
      // 需要退货才让用户填写物流
      const { isReturn } = this;
      return Number(isReturn) !== 2;
    },
  },
  async created() {
    if (this.showAddress) {
      await this.fetchAddressList();
    }
  },
  methods: {
    ...mapMutations('address', [
      'clearData',
    ]),
    getExpress({ key, title }) {
      this.delivery.expressCode = key;
      this.delivery.expressName = title;
      this.isShowExpressPicker = false;
    },
    async submitRefundExpress() {
      const {
        delivery: {
          expressName, expressSn, expressCode, expressFee,
        },
      } = this;
      try {
        const param = {};
        param.id = this.id;
        if (this.showUserAddress) {
          if (!this.nowAddressId) {
            this.$toast('请选择收货地址');
            return;
          }
          param.userAddressId = this.nowAddressId;
        }
        if (this.showIsReturn) {
          if (!expressName) {
            this.$toast('请填写物流公司');
            return;
          }
          if (!expressSn) {
            this.$toast('请填写物流单号');
            return;
          }
          if (expressFee && !checkNumber(expressFee)) {
            this.$toast('运费格式不正确');
            return;
          }
          param.expressName = expressName;
          param.expressSn = expressSn;
          param.expressCode = expressCode;
          param.expressFee = Number(expressFee);
        } else {
          param.expressName = '商家已确认无需寄回';
          param.expressSn = '#';
        }
        await orderApi.submitRefundExpress(param);
        this.$toast('提交成功');
        this.$router.go(-1);
      } catch (error) {
        this.$toast(`提交失败:${error.message}`, 3000);
      }
    },
    // 获取地址
    async fetchAddressList() {
      const data = await userApis.getAddressList();
      if (Array.isArray(data)) {
        let adderss;
        if (this.addressId) {
          this.nowAddressId = this.addressId;
          this.clearData();
        }
        if (!this.nowAddressId) {
          /* 没有id则用默认值 */
          [adderss] = data.filter(f => f.isDefault);
        } else {
          [adderss] = data.filter(f => f.addressId === this.nowAddressId);
          if (!adderss) {
            /* 如果没匹配到数据 说明地址被删除了 */
            this.$router.replace('/refund/express');
            /* 安卓端 页面刷新 title就会变化 所以在此需要再执行一遍 */
            MgtvApi.setWebviewTitle({ title: '芒果好物' });
            this.nowAddressId = 0;
          }
        }
        if (!_.isEmpty(adderss)) {
          this.nowAddressId = adderss.addressId;
          this.nowAddress = adderss;
        }
        if (!data.length) {
          this.hasNoAddress = 1;
        } else {
          this.hasNoAddress = 0;
        }
      }
    },
    gotoEdit() {
      this.$router.push({ path: '/address/manage', query: { goback: 1 } });
    },
    showAddress,
  },
};
</script>
<style lang="scss">
.refund-express {
  height: 100%;
  box-sizing: border-box;

  &__mark {
    margin-top: 50px;
    padding: 0px 20px;
  }

  &__main {
    height: 100%;
    font-size: 28px;
  }

  &__common {
    display: flex;
    padding: 15px 30px;
    align-items: center;
    background: #fff;

    span {
      margin-right: 20px;
    }

    &-input {
      flex: 1;
      height: 40px;
      font-size: 28px;
    }

    &-check {
      flex: 1;
      height: 40px;
      font-size: 26px;
    }
  }

  &__info {
    padding: 15px 30px;
  }

  &__button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }

  &__address {
    padding: 34px 26px;
    background: #ffffff;
    border-radius: 20px;
    margin: 0px 0px 20px 0px;

    &-user {
      font-size: 28px;
      color: #000000;
      margin-bottom: 20px;
    }

    &-detail {
      display: flex;
      align-items: center;

      div:nth-child(1),
      div:nth-child(3) {
        width: 30px;
      }

      div:nth-child(2) {
        flex: 1;
        font-size: 30px;
        margin: 0 40px;
        color: #000000;
      }
    }

    &-error {
      font-size: 20px;
      color: #f47125;
      padding: 10px 60px 0 60px;
      word-break: break-all;
    }
  }
}
</style>
